import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import IndicatorHeaderSection, {
  IndicatorHeaderSectionProps,
} from './IndicatorHeaderSection';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const StyledDiv = styled.div`
  text-align: center;
  padding: ${SPACERS.medium};
  border-bottom: 1px solid ${COLORS.grayLight};
  .indicator-header-sections {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${SPACERS.medium};
    margin-bottom: ${SPACERS.small};
  }
`;

const IndicatorsHeader: React.FC<IndicatorHeaderSectionProps> = props => {
  return (
    <StyledDiv>
      <TrueImpactText variant="heading-label" color="blackPure">
        Forecast progress
      </TrueImpactText>
      <div className="indicator-header-sections">
        <IndicatorHeaderSection
          {...props}
          sectionKey="capacityDevelopment"
          sectionName="Program Development"
        />
        <IndicatorHeaderSection
          {...props}
          sectionKey="reach"
          sectionName="Reach"
        />
        <IndicatorHeaderSection
          {...props}
          sectionKey="learn"
          sectionName="Learn"
        />
        <IndicatorHeaderSection {...props} sectionKey="act" sectionName="Act" />
        <IndicatorHeaderSection
          {...props}
          sectionKey="catalyzed"
          sectionName="Catalyzed"
        />
        <IndicatorHeaderSection
          {...props}
          sectionKey="succeed"
          sectionName="Succeed"
        />
      </div>
      <TrueImpactText variant="body-small-italic" color="grayDarkest">
        Hover over the stages above to view indicator forecast details you’ve
        entered.
      </TrueImpactText>
    </StyledDiv>
  );
};

export default IndicatorsHeader;
